// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"bea555439b6cd5f1e80d","655":"8769579ee4b545f119ed"}[chunkId] + ".js";
};